import { render, staticRenderFns } from "./CalendarEventFooterAdministerButtons.vue?vue&type=template&id=67c27e44&scoped=true&"
import script from "./CalendarEventFooterAdministerButtons.vue?vue&type=script&lang=js&"
export * from "./CalendarEventFooterAdministerButtons.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEventFooterAdministerButtons.vue?vue&type=style&index=0&id=67c27e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c27e44",
  null
  
)

export default component.exports